import {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Button, Form, Icon} from 'semantic-ui-react';
import './AdminPhotos.scss';
import AnalyticsGateway from 'lib/AnalyticsGateway';

class AdminPhotos extends PureComponent {
  static propTypes = {
    images: PropTypes.arrayOf(PropTypes.shape({
      thumbnail: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
    })),
    onDeleteImage: PropTypes.func.isRequired,
    onLoad: PropTypes.func.isRequired,
    onUploadImage: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.props.onLoad();
  }

  uploadFile = () => {
    const files = this._fileInput.querySelector('[type=file]').files;
    if (files.length) {
      this.props.onUploadImage(files[0]);

      AnalyticsGateway.sendEvent({
        eventName: 'Select Image',
        properties: [
          {label: 'Uploaded Large Cover Photo', value: files[0].name},
        ],
      });
    }
  };

  render() {
    const {images, onDeleteImage} = this.props;

    return (
      <div className="admin-photos">
        <header className="admin-photos-header">
          <h1 className="admin-photos-title">Cover Page Images</h1>
        </header>
        <div style={{display: 'flex', flexDirection: 'row'}} ref={(ref) => this._fileInput = ref}>
            <Form.Input label="Upload file (dimensions: 2056 x 2178)" type="file"/>
            <Button onClick={this.uploadFile}>Upload</Button>
        </div>
        <div className="images">
          {
            images && images.map(({image, thumbnail}, idx) => {
              const name = thumbnail.substring(thumbnail.lastIndexOf('/') + 1);

              return (
                <div className="image" title={name} key={name}>
                  {/* eslint-disable-next-line */}
                  <Icon name="delete" onClick={() => window.confirm(`Really delete ${name}?`) && onDeleteImage(image)}/>
                  <img key={idx} src={thumbnail} alt={name}/>
                  <span className="photo-name">{name}</span>
                </div>
              );
            })
          }
        </div>
      </div>
    );
  }
}

export default AdminPhotos;
